import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import StarRating from './Questions/StarRating';
import RadioInputGroup from '../common/RadioInputGroup';
import TextAreaInput from '../common/TextAreaInput';
import { postRequest, putRequest } from '../../requestUtils';
import './Review.scss';
var instantiateRatings = function instantiateRatings(categories) {
  return categories.map(function (category) {
    return {
      id: null,
      score: null,
      rating_category_id: category.id
    };
  });
};
var TEXT_QUESTIONS = [{
  number: 3,
  code: 'public_review',
  dist: 'Public Review',
  question: 'Share your experience working with',
  note: 'Note: This review will be shared with the consultant and visible on their profile.'
}, {
  number: 4,
  code: 'private_review',
  dist: 'Private Review',
  question: 'Share with Clora an internal feeback for',
  note: 'Note: This review will remain private and only shared internally with Clora.'
}];
var getAverageScore = function getAverageScore(ratings) {
  return (ratings.reduce(function (prev, curr) {
    return prev + curr.score;
  }, 0) / ratings.length).toFixed(1);
};
var Review = /*#__PURE__*/function (_Component) {
  function Review(props) {
    var _this;
    _classCallCheck(this, Review);
    _this = _callSuper(this, Review, [props]);
    var review = props.review;
    _this.state = {
      edit: props.edit,
      ratings: review.review_ratings.length > 0 ? review.review_ratings : instantiateRatings(review.categories),
      error: false,
      success: false,
      recommend: review ? review.recommend : true,
      publicReview: review ? review.public_review : '',
      privateReview: review ? review.private_review : '',
      published: review["public"],
      publishedAt: review.published_at
    };
    _this.handleReviewSave = _this.handleReviewSave.bind(_this);
    _this.handleUserInput = _this.handleUserInput.bind(_this);
    _this.handleAPISync = _this.handleAPISync.bind(_this);
    _this.handlePublishReview = _this.handlePublishReview.bind(_this);
    return _this;
  }
  _inherits(Review, _Component);
  return _createClass(Review, [{
    key: "handleAPISync",
    value: function handleAPISync(path, params, token, fxn, success) {
      var _this2 = this;
      var callback = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
      fxn(path, params, token).then(function () {
        window.scrollTo(0, 0);
        _this2.setState({
          error: false,
          success: success,
          edit: false
        });
        callback();
      })["catch"](function (error) {
        window.scrollTo(0, 0);
        _this2.setState({
          error: error.message,
          success: false
        });
      });
    }
  }, {
    key: "handlePublishReview",
    value: function handlePublishReview() {
      var _this3 = this;
      var _this$props = this.props,
        projectResourceId = _this$props.projectResourceId,
        review = _this$props.review,
        csrfToken = _this$props.csrfToken;
      var published = this.state.published;
      this.handleAPISync("/projects/".concat(projectResourceId, "/reviews/").concat(review.resource_id, "/publish"), {
        review: {
          "public": !published
        }
      }, csrfToken, putRequest, "Review ".concat(published ? 'un' : '', "published."), function () {
        _this3.setState({
          published: !published,
          publishedAt: null
        });
      });
    }
  }, {
    key: "handleReviewSave",
    value: function handleReviewSave() {
      var _this$state = this.state,
        ratings = _this$state.ratings,
        recommend = _this$state.recommend,
        publicReview = _this$state.publicReview,
        privateReview = _this$state.privateReview;
      var _this$props2 = this.props,
        review = _this$props2.review,
        projectResourceId = _this$props2.projectResourceId,
        csrfToken = _this$props2.csrfToken;
      var hasInvalidRatings = ratings.find(function (_ref) {
        var score = _ref.score;
        return !score;
      });
      if (hasInvalidRatings) {
        this.setState({
          success: false,
          error: "Please make sure you're rating all the categories."
        }, function () {
          return window.scrollTo(0, 0);
        });
        return;
      }
      var saveReview = {
        reviewee_id: review.reviewee_id,
        recommend: recommend,
        public_review: publicReview,
        private_review: privateReview,
        review_ratings_attributes: ratings.map(function (rating) {
          return {
            id: rating.id,
            rating_category_id: rating.rating_category_id,
            score: rating.score
          };
        })
      };
      this.handleAPISync(review.resource_id ? "/projects/".concat(projectResourceId, "/reviews/").concat(review.resource_id) : "/projects/".concat(projectResourceId, "/reviews"), {
        review: saveReview
      }, csrfToken, review.resource_id ? putRequest : postRequest, 'Review saved.');
    }
  }, {
    key: "handleUserInput",
    value: function handleUserInput(type, value, id) {
      var ratings = this.state.ratings;
      if (type === 'ratings') {
        ratings.find(function (r) {
          return r.rating_category_id === id;
        }).score = value;
        this.setState(_defineProperty({}, type, ratings));
      } else {
        this.setState(_defineProperty({}, type, value));
      }
    }
  }, {
    key: "renderActionButton",
    value: function renderActionButton() {
      var _this4 = this;
      var edit = this.state.edit;
      var _this$props3 = this.props,
        editable = _this$props3.editable,
        review = _this$props3.review;
      if (review.resource_id && edit && editable) {
        return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("button", {
          id: "review-cancel-changes",
          className: "btn btn-secondary-no-border bigger-button full-width btn-review",
          onClick: function onClick() {
            return _this4.setState({
              edit: false
            });
          }
        }, "Cancel Changes"), /*#__PURE__*/React.createElement("button", {
          id: "review-save-changes",
          className: "btn btn-primary bigger-button full-width btn-review",
          onClick: this.handleReviewSave
        }, "Save Changes"));
      }
      if (edit) {
        return /*#__PURE__*/React.createElement("button", {
          id: "review-save-feedback",
          className: "btn btn-primary bigger-button full-width btn-review",
          onClick: this.handleReviewSave
        }, "Save Feedback");
      }
      return null;
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      var _this5 = this;
      var _this$props4 = this.props,
        isRep = _this$props4.isRep,
        review = _this$props4.review;
      var published = this.state.published;
      if (review && (isRep || review.editable)) {
        return /*#__PURE__*/React.createElement("div", {
          className: "g-row reviews-header  mb-3 "
        }, !isRep && /*#__PURE__*/React.createElement("div", {
          className: "g-column g-column--centered"
        }, /*#__PURE__*/React.createElement("div", null, "You can edit this review until", /*#__PURE__*/React.createElement("strong", {
          className: "ms-2 me-2"
        }, review.editable_deadline))), /*#__PURE__*/React.createElement("div", {
          className: "g-column g-column--centered"
        }, /*#__PURE__*/React.createElement(Button, {
          id: "review-edit-review",
          variant: "secondary",
          onClick: function onClick() {
            return _this5.setState({
              edit: true
            });
          }
        }, "Edit Review")), /*#__PURE__*/React.createElement("div", {
          className: "g-column g-column--centered"
        }, isRep && review.resource_id && /*#__PURE__*/React.createElement(Button, {
          id: "review-publish-review",
          variant: "primary ms-2",
          onClick: this.handlePublishReview
        }, published ? 'Unpublish' : 'Publish')));
      }
      return null;
    }
  }, {
    key: "render",
    value: function render() {
      var _this6 = this;
      var _this$state2 = this.state,
        edit = _this$state2.edit,
        error = _this$state2.error,
        success = _this$state2.success,
        ratings = _this$state2.ratings,
        recommend = _this$state2.recommend,
        published = _this$state2.published,
        publishedAt = _this$state2.publishedAt;
      var _this$props5 = this.props,
        review = _this$props5.review,
        editable = _this$props5.editable;
      return /*#__PURE__*/React.createElement("div", {
        className: "reviews-container style-guide"
      }, /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, review.resource_id && editable && this.renderActions()), /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, /*#__PURE__*/React.createElement("h2", {
        className: "reviews-intro normal-weight"
      }, "Rate your experience with", ' ', /*#__PURE__*/React.createElement("strong", null, review.consultant_name), ' ', "for", ' ', /*#__PURE__*/React.createElement("strong", null, review.project_name))), publishedAt ? /*#__PURE__*/React.createElement("div", {
        className: "g-row mt-3"
      }, "This review was", ' ', published ? '' : 'un', "published on", ' ', publishedAt, ".") : '', /*#__PURE__*/React.createElement("div", {
        className: "g-row"
      }, success && /*#__PURE__*/React.createElement("div", {
        className: "success"
      }, /*#__PURE__*/React.createElement("span", null, success))), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
        className: "reviews-question"
      }, /*#__PURE__*/React.createElement("p", {
        className: " mb-3 "
      }, "1. How would you rate ".concat(review.first_name, "'s performance during this project in terms of:"), /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, "*")), review.categories.map(function (_ref2) {
        var id = _ref2.id,
          name = _ref2.name;
        return /*#__PURE__*/React.createElement(StarRating, {
          edit: edit,
          rating: ratings.find(function (r) {
            return r.rating_category_id === id;
          }),
          id: id,
          name: name,
          handleUserInput: _this6.handleUserInput
        });
      }), /*#__PURE__*/React.createElement("div", {
        className: "star-total"
      }, "Average Score:", getAverageScore(ratings))), error && /*#__PURE__*/React.createElement("div", {
        className: "error"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-exclamation-triangle"
      }), /*#__PURE__*/React.createElement("span", null, error)), /*#__PURE__*/React.createElement("div", {
        className: "reviews-question recommendation"
      }, /*#__PURE__*/React.createElement("p", {
        className: "body-text-1"
      }, "2. Would you recommend", ' ', review.first_name, "?", /*#__PURE__*/React.createElement("span", {
        className: "text-danger"
      }, "*")), edit ? /*#__PURE__*/React.createElement(RadioInputGroup, {
        options: [{
          label: 'Yes',
          value: true
        }, {
          label: 'No',
          value: false
        }],
        handleInputChange: function handleInputChange(option) {
          return _this6.handleUserInput('recommend', option.value);
        },
        selected: recommend,
        name: "recommendation",
        className: "ml-40 mt-3"
      }) : /*#__PURE__*/React.createElement("div", {
        className: "ml-40 mt-3"
      }, recommend ? 'Yes' : 'No')), TEXT_QUESTIONS.map(function (question) {
        return /*#__PURE__*/React.createElement("div", {
          className: "reviews-question recommendation"
        }, /*#__PURE__*/React.createElement("p", {
          className: "body-text-1  mb-3 "
        }, /*#__PURE__*/React.createElement("p", null, question.number, ".", ' ', /*#__PURE__*/React.createElement("strong", null, question.dist), " - ".concat(question.question, " ").concat(review.first_name), ' ', /*#__PURE__*/React.createElement("u", null, "during this project.")), /*#__PURE__*/React.createElement("div", {
          className: "body-text-2 muted-gray-text"
        }, question.note)), edit ? /*#__PURE__*/React.createElement(TextAreaInput, {
          className: "form-control fs-hide ".concat(question.code),
          placeholder: "Type your review here...",
          textAreaPrompt: "",
          rows: 3,
          value: _this6.state[question.code],
          onAnswerChange: function onAnswerChange(v) {
            return _this6.handleUserInput(question.code, v);
          }
        }) : /*#__PURE__*/React.createElement("div", null, _this6.state[question.code]));
      }), /*#__PURE__*/React.createElement("div", {
        className: "reviews-footer"
      }, this.renderActionButton())));
    }
  }]);
}(Component);
export { Review as default };
Review.propTypes = {
  edit: PropTypes.bool,
  editable: PropTypes.bool,
  review: PropTypes.shape({}),
  projectResourceId: PropTypes.string,
  csrfToken: PropTypes.string.isRequired,
  isRep: PropTypes.bool
};
Review.defaultProps = {
  review: {
    review_ratings: []
  },
  edit: false,
  editable: false,
  projectResourceId: null,
  isRep: false
};